import { render, staticRenderFns } from "./OrderSum.vue?vue&type=template&id=1d170225&scoped=true&"
import script from "./OrderSum.vue?vue&type=script&lang=js&"
export * from "./OrderSum.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d170225",
  null
  
)

export default component.exports